// 正则
const ISMAIL = (rule, value, callback) => {
	const age =
		/^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/ // Email格式的验证
	if (!age.test(value)) {
		callback(new Error('请输入正确格式的Email'))
	} else {
		callback()
	}
}
const ISNUM = (rule, value, callback) => {
	const age = /^[0-9]*$/ // 只能输入数值类型
	if (!age.test(value)) {
		callback(new Error('只能为数值类型'))
	} else {
		callback()
	}
}
const CHARACTRS = (rule, value, callback) => {
	const age = /^[\u0391-\uFFE5A-Za-z0-9]*$/ // 只能输入数字，大小写英文
	if (!age.test(value)) {
		callback(new Error('不能输入特殊字符'))
	} else {
		callback()
	}
}
const PHONE = (rule, value, callback) => {
	const phone = /^[1][3,4,5,7,8,9][0-9]{9}$/ // 手机格式
	if (!phone.test(value)) {
		callback(new Error('手机格式不正确'))
	} else {
		callback()
	}
}
export default {
	ISMAIL,
	ISNUM,
	CHARACTRS,
	PHONE
}
